import React from 'react';
import withView from '../../../docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormInput from '../../../../../library/form/components/FormInput';

const SOSearchBatchAction = (props) => {
    const { formObject, selectedDids } = props;

    return (
        <div className="uiFlexBox3">
            <FormInput formObject={formObject} rowKey="" className="uiInput" style={{ width: "120px" }}
                format="#" placeholder="Invoice Amount..." action={{ InputType: "input", paramName: "amountDue" }}
            />
            <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                starIcon="adds"
                tooltip="Create Vendor Invoice for the selected Service Order"
                action={{ actionId: "import", actionMessage: "Processing Action", actionName: "invcomp", 
                    actionParam: { imInvAmt: "#amountDue", tdtId: "304", is:"5", dIds:selectedDids.join(",") }, containerKey:"redirect" }}
                text={<SarasTrans value="Vendor Invoice" />}>
            </FormButton>
        </div>
    )
}

export default withView(SOSearchBatchAction, "", "");